export default __webpack_public_path__ + "static/media/arrow-direction-up.bc22f9b2.svg";